import { useState, useCallback } from 'react';
import { getEmailValidationError } from '../utils/emailValidation';

/**
 * Real-time email field validation (matches CMS contact form behavior).
 */
const useEmailFieldValidation = ({
  requiredMessage = 'Email is required',
  invalidMessage,
  extraValidator,
} = {}) => {
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState(null);

  const validate = useCallback(
    (value) =>
      getEmailValidationError(value, {
        requiredMessage,
        invalidMessage,
        extraValidator,
      }),
    [requiredMessage, invalidMessage, extraValidator]
  );

  const onEmailChange = useCallback(
    (value) => {
      setTouched(true);
      setError(validate(value));
    },
    [validate]
  );

  const onEmailBlur = useCallback(
    (value) => {
      setTouched(true);
      setError(validate(value));
    },
    [validate]
  );

  const validateEmailForSubmit = useCallback(
    (value) => {
      setTouched(true);
      const nextError = validate(value);
      setError(nextError);
      return !nextError;
    },
    [validate]
  );

  const resetEmailValidation = useCallback(() => {
    setTouched(false);
    setError(null);
  }, []);

  return {
    emailTouched: touched,
    emailError: error,
    onEmailChange,
    onEmailBlur,
    validateEmailForSubmit,
    resetEmailValidation,
    setEmailTouched: setTouched,
    setEmailError: setError,
  };
};

export default useEmailFieldValidation;
